import React from 'react';

type Props = { title?: string; value: string; boldValue?: boolean };

export const DetailsSingleDatum: React.FC<Props> = ({ title, value, boldValue }) =>
  value ? (
    <div className="w-100 mb-3">
      {title && <p className="caption font__grey tran-uppercase">{title}</p>}
      <p className={boldValue ? 'semibold' : ''}>{value}</p>
    </div>
  ) : null;
